const UserPolicy = {
  MenuEditor: {
    id: "e6fd5538-9ee7-47cf-a3db-e6f675103776",
    code: "MenuEditor"
  },
  PagesEditor: {
    id: "405851f5-4845-4914-bad5-c025f3f08188",
    code: "PagesEditor"
  },
  PublicArticlesEditor: {
    id: "3c0b6344-8a34-4359-8092-2cfabcbdb275",
    code: "PublicArticlesEditor"
  },
  NewsEditor: {
    id: "c78f8f72-6ed1-4413-8713-7ce1e5728ba1",
    code: "NewsEditor"
  },
  SurveyEditor: {
    id: "8ea0d0b7-0fcf-44ad-adfa-642c1a663ced",
    code: "SurveyEditor"
  }
};
Object.values(UserPolicy);
export {
  UserPolicy
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVXNlclBvbGljeS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy9Vc2VyUG9saWN5LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBVc2VyUG9saWN5ID0ge1xuXHRNZW51RWRpdG9yOiB7XG5cdFx0aWQ6IFwiZTZmZDU1MzgtOWVlNy00N2NmLWEzZGItZTZmNjc1MTAzNzc2XCIsXG5cdFx0Y29kZTogXCJNZW51RWRpdG9yXCIsXG5cdH0sXG5cdFBhZ2VzRWRpdG9yOiB7XG5cdFx0aWQ6IFwiNDA1ODUxZjUtNDg0NS00OTE0LWJhZDUtYzAyNWYzZjA4MTg4XCIsXG5cdFx0Y29kZTogXCJQYWdlc0VkaXRvclwiLFxuXHR9LFxuXHRQdWJsaWNBcnRpY2xlc0VkaXRvcjoge1xuXHRcdGlkOiBcIjNjMGI2MzQ0LThhMzQtNDM1OS04MDkyLTJjZmFiY2JkYjI3NVwiLFxuXHRcdGNvZGU6IFwiUHVibGljQXJ0aWNsZXNFZGl0b3JcIixcblx0fSxcblx0TmV3c0VkaXRvcjoge1xuXHRcdGlkOiBcImM3OGY4ZjcyLTZlZDEtNDQxMy04NzEzLTdjZTFlNTcyOGJhMVwiLFxuXHRcdGNvZGU6IFwiTmV3c0VkaXRvclwiLFxuXHR9LFxuXHRTdXJ2ZXlFZGl0b3I6IHtcblx0XHRpZDogXCI4ZWEwZDBiNy0wZmNmLTQ0YWQtYWRmYS02NDJjMWE2NjNjZWRcIixcblx0XHRjb2RlOiBcIlN1cnZleUVkaXRvclwiLFxuXHR9LFxufTtcblxuZXhwb3J0IGNvbnN0IFVzZXJQb2xpY3lBcnJheSA9IE9iamVjdC52YWx1ZXMoVXNlclBvbGljeSk7XG5cbmV4cG9ydCBjb25zdCBnZXRVc2VyUG9saWN5QnlJZCA9IChpZCkgPT5cblx0VXNlclBvbGljeUFycmF5LmZpbmQoKHgpID0+IHguaWQgPT09IGlkKTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBWSxNQUFDLGFBQWE7QUFBQSxFQUN6QixZQUFZO0FBQUEsSUFDWCxJQUFJO0FBQUEsSUFDSixNQUFNO0FBQUEsRUFDTjtBQUFBLEVBQ0QsYUFBYTtBQUFBLElBQ1osSUFBSTtBQUFBLElBQ0osTUFBTTtBQUFBLEVBQ047QUFBQSxFQUNELHNCQUFzQjtBQUFBLElBQ3JCLElBQUk7QUFBQSxJQUNKLE1BQU07QUFBQSxFQUNOO0FBQUEsRUFDRCxZQUFZO0FBQUEsSUFDWCxJQUFJO0FBQUEsSUFDSixNQUFNO0FBQUEsRUFDTjtBQUFBLEVBQ0QsY0FBYztBQUFBLElBQ2IsSUFBSTtBQUFBLElBQ0osTUFBTTtBQUFBLEVBQ047QUFDRjtBQUUrQixPQUFPLE9BQU8sVUFBVTsifQ==
